import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import Newsletter from "../components/site/home/Newsletter";
import Breadcrumbs from "../components/site/Breadcrumbs";
import { useSeo } from "../hooks/useSeo";
import { GUIDES } from "../data/sitePages";
import { article, breadcrumb } from "../lib/jsonld";

export default function Guide() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const guide = GUIDES.find((g) => g.slug === slug);
  const title = guide ? guide.title : "Guide";
  const crumbs = [{ name: "Home", path: "/" }, { name: "Guides", path: "/guides" }, { name: title, path: `/guides/${slug}` }];

  // Guides are not ready yet — keep them out of the index until published.
  // Article schema is prepared for when full content is added.
  useSeo({
    title: `${title} (Coming Soon) | YogaToYacht`,
    description: `${title} — an in-depth YogaToYacht guide, coming soon.`,
    path: `/guides/${slug}`,
    noindex: true,
    jsonLd: [
      article({ title, description: `${title} — an in-depth YogaToYacht guide, coming soon.`, path: `/guides/${slug}`, date: new Date().toISOString().slice(0, 10) }),
      breadcrumb(crumbs),
    ],
  });

  return (
    <div data-testid="guide-page" className="bg-brand-bg text-brand-ink">
      <Header onNavigate={() => navigate("/")} />
      <section className="mx-auto max-w-[820px] px-6 pt-40 pb-24 md:px-10">
        <Breadcrumbs items={crumbs} />
        <div className="mt-8 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-bg2 px-4 py-1.5 text-xs font-medium text-brand-inkSoft">
          <Clock size={14} /> Guide coming soon
        </span>
        <h1 className="font-display mt-6 text-4xl leading-tight text-brand-ink md:text-5xl">{title}</h1>
        <p className="mx-auto mt-5 max-w-xl text-brand-inkSoft">
          We&apos;re writing this guide right now. Join the list below and we&apos;ll let you know the
          moment it&apos;s published — along with other hand-picked retreat ideas.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" data-testid="guide-home" className="inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-sm font-medium text-white">
            <ArrowLeft size={15} /> Back to home
          </Link>
          <Link to="/guides" className="inline-flex items-center gap-2 rounded-full border border-brand-line px-6 py-3 text-sm font-medium text-brand-ink">
            All guides
          </Link>
        </div>
        </div>
      </section>
      <Newsletter />
      <Footer />
    </div>
  );
}
